import { render, staticRenderFns } from "./GoogleMyBusinessLoginCard.vue?vue&type=template&id=0dd8e97a"
import script from "./GoogleMyBusinessLoginCard.vue?vue&type=script&lang=ts"
export * from "./GoogleMyBusinessLoginCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports